import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/SubstanceComponent.css';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const SubstanceComponent = () => {
  const [substances, setSubstances] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [substancesPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedSubstance, setSelectedSubstance] = useState(null);
  const navigate = useNavigate();

  const fetchSubstances = async (page = 1) => {
    setLoading(true);
    try {
      const res = await axios.get(`http://197.156.76.122/api/substance/?page=${page}`);
      const data = res.data;
      const items = Array.isArray(data) ? data : data.results || [];
      setSubstances(items);
      setTotalCount(Array.isArray(data) ? data.length : data.count || 0);
    } catch (e) {
      console.error('Failed to fetch substances', e);
      setSubstances([]);
      setTotalCount(0);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSubstances(currentPage);
  }, [currentPage]);

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toISOString().split('T')[0];
  };

  const truncateList = (list, count = 5) => {
    if (!Array.isArray(list)) return 'N/A';
    if (list.length <= count) return list.join('; ');
    return list.slice(0, count).join('; ') + '; ...';
  };

  const joinList = (list) => (Array.isArray(list) ? list.join('; ') : list);

  return (
    <div className="substance-container">
      <h2>{totalCount} Substance Results</h2>

      {loading && <p>Loading substances...</p>}
      {!loading && substances.length === 0 && <p>No substances found.</p>}

      {/* ✅ List View */}
      {!selectedSubstance && substances.map((sub) => (
        <div key={sub.record_number} className="substance-card">
          <div className="structure-preview">There is no structure</div>

          <div className="substance-details">
                 {/* 🔙 Back to Home (ADD THIS HERE) */}
		    <button 
		      className="back-button"
		      onClick={() => navigate('/')}
		    >
		      <FaArrowLeft /> Back to Home
		    </button>
            <h3 className="substance-title">
              <button
                className="link-button"
                onClick={() => setSelectedSubstance(sub)}
              >
                {truncateList(sub.depositor_synonyms) || 'Untitled Substance'}
              </button>
            </h3>

            <p>
              <strong>Substance SID:</strong>{' '}
              <button
                className="link-button"
                onClick={() => setSelectedSubstance(sub)}
              >
                {sub.record_number}
              </button>
            </p>

            <p>
              <strong>Data Source:</strong> {sub.source || 'N/A'}{' '}
              {sub.external_id && (
                <> | <strong>External ID:</strong> {sub.external_id}</>
              )}
            </p>

            <p><strong>Data Source Category:</strong> {sub.source_category || 'N/A'}</p>
            <p>
              <strong>Deposit Date:</strong> {formatDate(sub.deposit_date)} |{' '}
              <strong>Last Modified Date:</strong> {formatDate(sub.modify_date)}
            </p>
          </div>
        </div>
      ))}

      {/* ✅ Pagination */}
      {!selectedSubstance && (
        <div className="pagination">
          <button onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}>
            ⬅ Prev
          </button>
          <span>
            Page {currentPage} of {Math.ceil(totalCount / substancesPerPage)}
          </span>
          <button
            onClick={() =>
              setCurrentPage((p) => (p < Math.ceil(totalCount / substancesPerPage) ? p + 1 : p))
            }
            disabled={currentPage === Math.ceil(totalCount / substancesPerPage)}
          >
            Next ➡
          </button>
        </div>
      )}

      {/* ✅ Full-Page Modal View */}
      {selectedSubstance && (
        <div className="modal-fullpage">
          <div className="modal-header">
            <button className="modal-back-btn" onClick={() => setSelectedSubstance(null)}>← Back</button>
            <h1>{joinList(selectedSubstance.depositor_synonyms) || 'Untitled Substance'}</h1>
          </div>

          <div className="modal-body">
            <div className="modal-structure">
              <div className="structure-preview-large">There is no structure</div>
            </div>

            <div className="modal-info">
              <p><strong>Substance SID:</strong> {selectedSubstance.record_number}</p>
              <p><strong>Source:</strong> {selectedSubstance.source || 'N/A'}</p>
              {selectedSubstance.external_id && (
                <p><strong>External ID:</strong> {selectedSubstance.external_id}</p>
              )}
              <p><strong>Source Category:</strong> {selectedSubstance.source_category || 'N/A'}</p>
              <p><strong>Deposit Date:</strong> {formatDate(selectedSubstance.deposit_date)}</p>
              <p><strong>Last Modified:</strong> {formatDate(selectedSubstance.modify_date)}</p>
              {selectedSubstance.record_description && (
                <p><strong>Description:</strong> {selectedSubstance.record_description}</p>
              )}
              {selectedSubstance.depositor_synonyms?.length > 0 && (
                <p><strong>Synonyms:</strong> {joinList(selectedSubstance.depositor_synonyms)}</p>
              )}

              <div className="modal-links">
                <h3>Related Links</h3>
                <ul>
                  {selectedSubstance.record_number && (
                    <li>
                      <a
                        href={`https://pubchem.ncbi.nlm.nih.gov/substance/${selectedSubstance.record_number}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        PubChem Substance
                      </a>
                    </li>
                  )}
                  {selectedSubstance.source && (
                    <li>
                      <a
                        href={`https://pubchem.ncbi.nlm.nih.gov/source/${encodeURIComponent(selectedSubstance.source)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        PubChem Source
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubstanceComponent;

